import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import MedicareCoverage from './MedicareCoverage';
import PlanTypeConf from './PlanTypeConf';
import PCP from './PCP';
import MailOrder from './MailOrder';

function Coverage() {
  return (
    <Routes>
      <Route path="medicare-coverage" element={<MedicareCoverage />} />
      <Route path="plan-type" element={<PlanTypeConf />} />
      <Route path="pcp" element={<PCP />} />
      <Route path="mailorder" element={<MailOrder />} />
    </Routes>
  );
}

export default Coverage;
